"use strict";
/*
 * Created on 9. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @author Radek Beran
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Approval status converter.
 *
 * @author Radek Beran
 */


var ReleaseEditInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ReleaseEditInfoConverter, _DataObjectConverter_);

  function ReleaseEditInfoConverter() {
    _classCallCheck(this, ReleaseEditInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseEditInfoConverter).apply(this, arguments));
  }

  return ReleaseEditInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ReleaseEditInfoConverter = ReleaseEditInfoConverter;